import { isCapacitorNative } from '@utils/capacitor-utils';
import { useKeycloakAuthWeb } from './useKeycloakAuthWeb.ts';
import { useKeycloakAuthCapacitor } from './useKeycloakAuthCapacitor.ts';

// Platform-specific Keycloak authentication hook selector
// Automatically selects appropriate implementation based on runtime environment
let useKeycloakAuth: () => ReturnType<typeof import('./useKeycloakAuthWeb').useKeycloakAuthWeb>;

// Use Capacitor-specific implementation for native mobile platforms
if (isCapacitorNative()) {
  useKeycloakAuth = useKeycloakAuthCapacitor;
} else {
  // Use web implementation for browser environments
  useKeycloakAuth = useKeycloakAuthWeb;
}

export { useKeycloakAuth };
